import React, { useContext } from 'react'
import MenuItemContent from '../../lib/react-storefront/menu/MenuItemContent'
import Link from 'next/link'
import MenuContext from '../../lib/react-storefront/menu/MenuContext'

function CustomMenuLeaf({ item, trackSelected, ...others }) {
  const { close, classes } = useContext(MenuContext)

  return (
    <Link href={item.href} as={item.as} legacyBehavior>
      <a 
        className={classes.link}
        onClick={close}
        style={{ textDecoration: 'none', color: 'inherit' }}
      >
        <MenuItemContent
          {...others}
          item={item}
          showExpander={false}
          leaf={true}
        />
      </a>
    </Link>
  )
}

export default React.memo(CustomMenuLeaf)
